
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

import { getGenderSelectorItems, getStateSelectorItems } from '@/utils/global.util';

@Component({
  components: {
  }
})
export default class WSAPageOne extends Vue {
  @Prop() model: WSAPageOneModel;
  formModel: WSAPageOneModel;

  data() {
    return {
      formModel: null
    }
  }

  created() {
    this.formModel = {
      ...this.model
    }
  }

  get states() {
    return getStateSelectorItems();
  }

  get genders() {
    return getGenderSelectorItems();
  }

  get howDidYouHearOptions() {
    const options = [
      'Cousins Subs Restaurant',
      'Cousins Subs Website',
      'Cousins Subs Email',
      'Radio Advertisement',
      'Scholarship Website',
      'School Staff Member',
      'Social Media'
    ];
    const results: SelectorItem[] = [];

    results.push({
      value: '',
      id: '',
      label: ''
    });

    options.forEach((state) => {
      results.push({
        value: state,
        id: state,
        label: state
      });
    });

    return results;
  }

  @Emit('nextPage')
  async submitHandler() {
    return { ...this.formModel };
  }
}
